module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"evidenceTitle":"Evidence"},"de":{"evidenceTitle":"Nachweise"}}')
  delete Component.options._Ctor
}
